import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

class VenueHGSuperPayReturn extends Component {
    componentDidMount() {
        const { returnStatus } = this.props.match.params;
        const profileId = sessionStorage.getItem("venueHgSuperPayProfileId") || "";

        if (returnStatus === "checkoutsuccess") {
            this.props.hgSuperPayAddonStore.loadAddonStatusForProfile(profileId);
            this.props.hgBillingStore.reloadAccessSynch();
            this.props.templateStore.openSnackbar("HG Super Pay subscription activated successfully!");
        } else if (returnStatus === "checkoutcancelled") {
            this.props.templateStore.openSnackbar("Checkout cancelled — no changes were made.");
        }

        if (profileId) {
            this.props.history.replace(
                `/venues/${profileId}/hg-super-pay`,
                returnStatus === "checkoutsuccess" ? { initialTab: 1 } : undefined
            );
        } else {
            this.props.history.replace("/venue");
        }
    }

    render() {
        return null;
    }
}

export default inject(
    "templateStore",
    "hgSuperPayAddonStore",
    "hgBillingStore"
)(withRouter(observer(VenueHGSuperPayReturn)));
